import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import FrontEndContext from "../../context/FrontEndContext";
import bssiLogo from "../../assets/images/bssi_logo_light.png";
import "./index.css";

export interface HeaderBarProps {
  name?: string;
  hideAuthentication?: boolean;
}

const HeaderBar = (props: HeaderBarProps) => {
  const navigate = useNavigate();
  const { name, hideAuthentication } = props;

  const { isAuthenticating, isAuthenticated, doLogin, doLogout } = useContext(FrontEndContext);
  const authText = isAuthenticating ? "Logging in..." : isAuthenticated ? "Logout" : "Login";
  const authHandler = isAuthenticated ? doLogout : doLogin;

  return (
    <div className="header-container">
      <div className="left-items">
        <div>
          <img className="bssi-logo" onClick={() => navigate("/")} src={bssiLogo} alt="BSSI logo" />
        </div>
      </div>
      <div className="middle-items">
        <div className="header-text">{name || ""}</div>
      </div>
      <div className="right-items">
        {!hideAuthentication && (
          <div className="header-text auth-text" onClick={() => !isAuthenticating && authHandler()}>
            {authText}
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderBar;
